<div class="card flex justify-content-center">
  <button (click)="showDialog()" class="reject">
    {{ 'label.Reject' | translate }}
  </button>
  <p-dialog
    [header]="'label.Information' | translate"
    [modal]="true"
    [(visible)]="visible"
    styleClass="dialog"
    [style]="{ width: '25rem' }"
  >
    <div class="dialog-container">
      <div class="text-field flex align-items-center gap-3 mb-3">
        <label for="username" class="font-semibold w-6rem">{{
          'label.CaptchaEntryRequest' | translate
        }}</label>
        <input
          #inputValue
          pInputText
          id="username"
          class="flex-auto"
          autocomplete="off"
        />
      </div>
      <div class="flex justify-content-end gap-2">
        <p-button
          [label]="'label.Save' | translate"
          (click)="setValue((visible = false), inputValue)"
        />
      </div>
    </div>
  </p-dialog>
</div>
